// extracted by mini-css-extract-plugin
export var black = "#000";
export var grey = "#e7e7e7";
export var grey120 = "#b9b9b9";
export var greyBg = "#fbfbfb";
export var greyBgDark = "#e9e9e9";
export var greyDark = "#4c4c4c";
export var primary = "#6d28d9";
export var primary120 = "#5720ae";
export var primary40 = "#c5a9f0";
export var secondary = "#eee6fa";
export var secondary120 = "#beb8c8";
export var secondary15 = "#fcfbfe";
export var secondary40 = "#f8f5fd";
export var white = "#fff";